import { Box, Stack, Typography } from "@mui/material";
import SectionCard from "../../../components/SectionCard";

const experiences = [
  {
    title: "ASIC Engineer",
    company: "Cisco",
    companyUrl: "https://www.cisco.com/",
    dates: "May 2026 – Present",
    bullets: [
      "Hardware development of Cisco Silicon One, the next-generation network silicon that powers modern AI, cloud, and internet infrastructure.",
    ],
  },
  {
    title: "Software Engineering Intern",
    company: "The Church of Jesus Christ of Latter Day Saints",
    companyUrl: "https://www.churchofjesuschrist.org/",
    dates: "Feb 2025 - Feb 2026",
    bullets: [
      "Development of a network management full-stack solution which organized and configured Cisco networking devices worldwide.",
    ],
  },
  {
    title: "Systems Engineering Intern",
    company: "L3Harris Technologies",
    companyUrl: "https://www.l3harris.com/",
    dates: "Jun 2025 – Aug 2025",
    bullets: [
      "Designed tools and systems as part of the Special Test Equipment Engineering team to maximize manufacturing floor output while ensuring testing accuracy of product.",
    ],
  },
];

function ExperienceEntry({ entry, isLast }) {
  return (
    <Stack direction="row" spacing={2} alignItems="stretch">
      {/* Timeline */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: 24,
        }}
      >
        {/* Bullet */}
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            bgcolor: "primary.main",
            mt: 1,
          }}
        />

        {/* Connector */}
        {!isLast && (
          <Box
            sx={{
              width: 2,
              flex: 1,
              minHeight: 48,
              mt: 1,
              bgcolor: "rgba(129,203,233,0.25)",
            }}
          />
        )}
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, pb: isLast ? 0 : 4 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {entry.title}
        </Typography>

        <Typography variant="body2" color="primary">
          <a
            href={entry.companyUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-link"
          >
            {entry.company}
          </a>
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {entry.dates}
        </Typography>

        <Box
          component="ul"
          sx={{
            pl: 0,
            m: 0,
            "& li": {
              mb: 0.5,
            },
          }}
        >
          {entry.bullets.map((bullet) => (
            <Typography variant="body2">{bullet}</Typography>
          ))}
        </Box>
      </Box>
    </Stack>
  );
}

export default function WorkExperience() {
  return (
    <SectionCard title="Experience">
      <Stack spacing={0}>
        {experiences.map((entry, index) => (
          <ExperienceEntry
            key={`${entry.company}-${entry.title}`}
            entry={entry}
            isLast={index === experiences.length - 1}
          />
        ))}
      </Stack>
    </SectionCard>
  );
}
